import { render } from "./UploadPopModelDiy.vue?vue&type=template&id=327fd53c&scoped=true"
import script from "./UploadPopModelDiy.vue?vue&type=script&lang=js"
export * from "./UploadPopModelDiy.vue?vue&type=script&lang=js"

import "./UploadPopModelDiy.vue?vue&type=style&index=0&id=327fd53c&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327fd53c"]])

export default __exports__